import { useState } from "react";

export default function AppClarifier() {
  const responses = [
    {
      id: "game",
      title: "A game",
      description: "Interactive entertainment",
      icon: "🎮",
    },
    {
      id: "tool",
      title: "A tool",
      description: "Utility or productivity app",
      icon: "🔧",
    },
    {
      id: "dashboard",
      title: "A dashboard",
      description: "Data visualization or management",
      icon: "📊",
    },
    {
      id: "website",
      title: "A website",
      description: "Informational or marketing",
      icon: "🌐",
    },
    {
      id: "integration",
      title: "An integration",
      description: "Connect to a service or API",
      icon: "🔗",
    },
    {
      id: "other",
      title: "Something else",
      description: "Tell me more",
      icon: "💡",
    },
  ];

  const [selected, setSelected] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-indigo-900 to-blue-900 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white/10 backdrop-blur-lg rounded-3xl shadow-2xl p-8 border border-white/20">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-3">
            What kind of app do you want to build?
          </h1>
          <p className="text-white/70 text-lg">Choose an option to help clarify your vision</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {responses.map((option) => (
            <button
              key={option.id}
              onClick={() => setSelected(option.id)}
              className={`
                group relative p-6 rounded-2xl text-left transition-all duration-200
                ${
                  selected === option.id
                    ? "bg-gradient-to-r from-purple-600 to-indigo-600 scale-105 shadow-xl"
                    : "bg-white/5 hover:bg-white/10 hover:scale-102 hover:shadow-lg"
                }
                border ${selected === option.id ? "border-white/30" : "border-white/10"}
              `}
            >
              <div className="flex items-start gap-4">
                <span className="text-3xl">{option.icon}</span>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-1">{option.title}</h3>
                  <p className="text-white/60 text-sm">{option.description}</p>
                </div>
              </div>
              {selected === option.id && (
                <div className="absolute inset-0 rounded-2xl ring-2 ring-white/50 ring-offset-2 ring-offset-transparent pointer-events-none" />
              )}
            </button>
          ))}
        </div>

        {selected && (
          <div className="mt-8 p-6 bg-white/5 rounded-2xl border border-white/10">
            <p className="text-white/90 text-center text-lg">
              You selected:{" "}
              <span className="font-semibold text-white">
                {responses.find((r) => r.id === selected)?.title}
              </span>
            </p>
            <p className="text-white/60 text-center text-sm mt-2">
              Tell me more about your idea and I'll help you build it
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
